import { useEffect, useState } from "react";
import { useFetch } from "../../custom/api";
import PaymentFailure from "./components/paymentFailure";
import PaymentSuccess from "./components/paymentSuccess";
import VerifyProcess from "./components/verifyProcess";


import { Link, useParams, useSearchParams } from "react-router-dom";

const VerifyPayment = () => {
  const { myFetch } = useFetch();
  let [searchParams, setSearchParams] = useSearchParams();
  let [paymentStatus, setPaymentStatus] = useState(null)

  const success = parseInt(searchParams.get('success'));
  const status = parseInt(searchParams.get('status'));
  const trackId = parseInt(searchParams.get('trackId'))
  const orderId = searchParams.get('orderId')

  useEffect(() => {
    const fetchData = async () => {
        const data = {success, status, trackId, orderId}
      const resp = await myFetch(`verify-payment`, { method: "POST", body: JSON.stringify(data), headers: { "Content-Type": "application/json" }});
      const r = await resp.json();
      console.log(r)
      setPaymentStatus(r);
    };
    fetchData();
  }, []);

  return (
    <>
    {paymentStatus === null  && <VerifyProcess></VerifyProcess> }
    {paymentStatus !== null  && paymentStatus.status === "error" && <PaymentFailure trackId={trackId} message= {paymentStatus.message} ></PaymentFailure> }
    {paymentStatus !== null  && paymentStatus.status === "success" && <PaymentSuccess trackId={trackId}></PaymentSuccess> }
    {/* {success === 1 && <PaymentSuccess trackId={trackId}></PaymentSuccess>} */}
    {/* {success === 0 && <PaymentFailure trackId={trackId}></PaymentFailure>} */}
    </>
  );
};

export default VerifyPayment;
